"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PopupContent_1 = require("./PopupContent");
exports.default = PopupContent_1.default;
//# sourceMappingURL=index.js.map